module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-observe"
  }, [_c('div', {
    staticClass: "company-observe__header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "company-observe__search"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "公司名称 / 超级管理员邮箱 / 企业前缀"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "keyword"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.companies,
      "border": "",
      "empty-text": "暂无企业数据"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "公司名称",
      "min-width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "超级管理员邮箱",
      "min-width": "220"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "prefix",
      "label": "企业前缀",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "server_uid",
      "label": "CRM服务器",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "today_session_num",
      "label": "当天会话数",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.today_session_num !== null) ? _c('span', [_vm._v(_vm._s(scope.row.today_session_num))]) : _c('el-tooltip', {
          attrs: {
            "content": "会话统计暂时不可用",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "company-observe__unavailable"
        }, [_vm._v("--")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "loading": _vm.observingPrefix === scope.row.prefix
          },
          on: {
            "click": function($event) {
              return _vm.observe(scope.row)
            }
          }
        }, [_vm._v("观察")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "company-observe__pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "current-page": _vm.page,
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageChanged
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("企业观察")]), _vm._v(" "), _c('p', [_vm._v("以独立观察身份进入企业管理员后台，不占用或踢出原管理员和客服登录。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-075c17f6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companyObserve/companyObserve.vue
// module id = 590
// module chunks = 1